import { render, staticRenderFns } from "./hometest.vue?vue&type=template&id=612cc244&scoped=true"
import script from "./hometest.vue?vue&type=script&lang=js"
export * from "./hometest.vue?vue&type=script&lang=js"
import style0 from "./hometest.vue?vue&type=style&index=0&id=612cc244&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612cc244",
  null
  
)

export default component.exports